import toast from 'react-hot-toast';
import { useSWRConfig } from 'swr';
import { captureException } from '@sentry/react';

import { Dialog } from '../../../components/dialog/Dialog';
import { createCustomer, CUSTOMERS_SWR_KEY } from '../models';
import type { CreateCustomerResponse } from '../endpoints/CreateCustomerEndpoint.types';
import { getDisplayError } from '../../../utils/get-display-error';
import { trackEvent } from '../../../utils/track-event';
import { CreateCustomerForm } from './CreateCustomerForm';

export interface ICreateCustomerDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreated: (created: CreateCustomerResponse) => void;
  initialName?: string;
}

export const CreateCustomerDialog: React.FC<ICreateCustomerDialogProps> = (props) => {
  const { isOpen, onClose, onCreated, initialName } = props;
  const { mutate } = useSWRConfig();

  return (
    // Not dismissable: this form is long enough that a stray outside click would
    // silently discard everything. Cancel is the way out.
    <Dialog isOpen={isOpen} onClose={onClose} title="Nieuwe klant" isDismissable={false}>
      <CreateCustomerForm
        initialName={initialName}
        onCancel={onClose}
        onSubmit={async (inputData) => {
          try {
            const created = await createCustomer(inputData);
            trackEvent('customer_created', {
              customer_id: created.id,
              country: inputData.country,
            });
            // The combobox's list cache is now stale — reopening it should show the new customer.
            await mutate((key) => Array.isArray(key) && key[0] === CUSTOMERS_SWR_KEY);
            onCreated(created);
            toast.success('Klant aangemaakt');
          } catch (err: any) {
            captureException(err);
            toast.error('Kon klant niet aanmaken: ' + getDisplayError(err));
          }
        }}
      />
    </Dialog>
  );
};
